
import {Component, Vue} from 'vue-property-decorator';
import AppPageHeader from "@/components/AppPageHeader.vue";
import DeviceStatsTable from "@/modules/DeviceStats/components/DeviceStatsTable.vue";

@Component({
  components: {
    DeviceStatsTable,
    AppPageHeader,
  },
})
export default class PageDeviceStats extends Vue {
  isLoading: boolean = true;

  async created() {
    try {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('initialized');

      await this.$store.dispatch('deviceStats/getDeviceStats');
      this.isLoading = false;
    }
    catch (error) { await this.$store.dispatch('handleError', error) }
  }

}
